global._ = require("lodash");

global.$ = global.jQuery = require("jquery");

//global.axios = require("axios");

//global.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
